<template>
  <div class="row">
    <div class="col-md-12">
      <h4 class="title">{{title}}</h4>
      <span style="display: inline-block">是否绑定gameid</span>
      <el-switch
        style="display: block"
        v-model="value4"
        active-color="#13ce66"
        inactive-color="#ff4949"
        active-text="否"
        inactive-text="是">
      </el-switch>
    </div>
    <div class="col-sm-12">
      <div class="pull-right">
        <el-button style="margin-left: 30px; width: 150px" type="success" @click="buildAccount">打包</el-button>
      </div>

    </div>
    <el-divider></el-divider>
    <div style="margin-top: 10px" class="col-md-14">
      <div class="title">
        <label style="margin-left: 80px;">选择游戏</label>
        <label style="margin-left: 140px;" type="success">渠道分类</label>
        <label style="margin-left: 120px;" type="success">请选择targetSDK版本</label>
        <label style="margin-left: 120px;" type="success">选择投放形式</label>
        <label style="margin-left: 130px;" type="info">选择投放分组</label>
        <label style="margin-left: 150px;" type="warning">选择用户</label>
        <label style="margin-left: 170px;" type="danger">选择渠道</label>
      </div>
      <div class="block">
        <el-select @change="selectGetGameId" v-model="selectGame" style="margin-left: 10px;" filterable
                   placeholder="请选择游戏">
          <el-option
            v-for="item in gamelist"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-select @change="selectChanel" v-model="channel_type" style="margin-left: 10px;width: 170px" filterable
                   collapse-tags
                   placeholder="请选择渠道分类">
          <el-option
            v-for="item in game_channellist"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-select v-model="selectTargetSDK" style="margin-left: 10px;" filterable
                   multiple
                   collapse-tags
                   placeholder="请选择targetSDK版本">
          <el-option
            v-for="item in game_targetSDKlist"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-select @change="selectGetPutStyleId" v-model="selectPtuType" style="margin-left: 10px;" filterable
                   placeholder="请选择投放形式">
          <el-option
            v-for="item in putInfolist"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-select @change="selectGetPutGroup" v-model="selectGroup" style="margin-left: 10px;" filterable
                   placeholder="请选择投放渠道分组">
          <el-option
            v-for="item in putGroup"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-select @change="selectGetUserName" v-model="selectUser" style="margin-left: 10px;" filterable
                   placeholder="请选择用户">
          <el-option
            v-for="item in userList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>


        <el-select
          v-model="selectChannel"
          multiple
          filterable
          collapse-tags
          style="margin-left: 10px;"
          placeholder="请选择渠道支持多选">
          <el-option
            v-for="item in channellist"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>

      </div>
    </div>
  </div>


</template>

<script>
  import {getFetch} from 'src/util/fetch'
  import {getchanels93} from "../../../../util/getchanels93";

  export default {
    data() {
      return {
        value4: true,
        floor: "jssy",
        game: "",
        user: "",
        type: "",
        cannel: "",
        channel_type: "",
        title: '第四事业部推广游戏打包',
        selectTargetSDK: [],
        selectGame: [],
        selectPtuType: [],
        selectGroup: [],
        selectUser: [],
        selectChannel: [],
        buildSendInfo: [],//最终打包数据
        currentGameId: "",//当前选中的gameid
        currentTargetSdkVersion: "",
        // currentShort_name:"",//当前选择的渠道标识（渠道号）
        // currentClick_url:"",//当前选择的监测链链接
        currentPutStyleId: "",//当前选择的投放形式id
        currentPutGroupId: "",//当前选择的投放渠道分组id
        currentUserName: "",//当前选择的用户名
        tableColumns: [//列表
          {
            prop: 'gid',
            label: '选择游戏',
            minWidth: 200
          },
          {
            prop: 'name',
            label: '选择投放形式',
            minWidth: 200
          },
          {
            prop: 'alias',
            label: '选择用户',
            minWidth: 200
          },
          {
            prop: 'father_path',
            label: '选择渠道',
            minWidth: 200
          },
        ],
        //游戏列表
        gamelist: [],
        game_targetSDKlist: [],
        gamelist_all_data: [],//请求到的完整数据
        game_channellist: [],
        //投放形式
        putInfolist: [],
        //投放分组
        putGroup: [],
        //用户数据
        userList: [],
        //渠道列表
        channellist: [],


      };
    },
    watch: {
      value4() {
        this.channelsData()
      },
      game(val) {
        //console.log(val);
        // this.user=val;
        // this.type=val;
      },
    },
    methods: {
      //捕获游戏选择操作
      selectGetGameId(vId) {
        this.currentGameId = vId;
        this.game_targetSDKlist = []
        this.selectTargetSDK = []
        this.selectChannel = []

        this.getChannel(vId)
      },
      selectChanel(channel_name) {
        this.channel_type = channel_name
        this.getTargetSdk(channel_name)
      },
      // selectGetTargetSdkVersion(vId) {
      //     this.currentTargetSdkVersion = vId;
      //     console.log(vId)
      // },
      //捕获投放形式选择操作
      selectGetPutStyleId(vId) {
        this.currentPutStyleId = vId;
        this.selectChannel = []
        this.channelGroups();
        this.channelsData();
      },

      //捕获投放渠道分组选择操作
      selectGetPutGroup(vId) {
        this.currentPutGroupId = vId;
        this.selectChannel = []
        this.channelsData();
      },

      //捕获用户名选择操作
      selectGetUserName(vId) {
        this.currentUserName = vId;
        this.selectChannel = []
        this.channelsData();
      },

      //打包操作
      buildAccount() {
        this.buildSendInfo = []
        var can_build = ""
        //console.log(this.selectTargetSDK)
        //console.log(this.selectChannel)
        for (let j = 0; j < this.selectTargetSDK.length; j++) {
          if (this.selectTargetSDK[j]) {
            for (var i = 0; i < this.selectChannel.length; i++) {
              for (var k = 0; k < this.channellist.length; k++) {
                if (this.selectChannel[i] === this.channellist[k].value) {
                  can_build = "true"
                  var info = {
                    gameid: this.currentGameId,
                    chennel_category: this.channel_type,
                    TargetSdkVersion: this.selectTargetSDK[j],
                    ad_putin_name: this.channellist[k].ad_putin_name,
                    short_name: this.channellist[k].short_name,
                    check_url: this.channellist[k].check_url
                  }
                  this.buildSendInfo.push(info)
                  break;
                }
              }
            }
          }
        }

        if (can_build == "true") {
          this.buildAPI()
        } else {
          this.$alert('参数信息不完整不能进行打包操作', '提示', {
            confirmButtonText: '确定',
            center: true,
            callback: action => {
              this.$message({
                type: 'info',
                center: true,
                message: `action: ${action}`
              });
            }
          });
        }

      },
      //获取渠道信息
      async getChannel(gid) {
        let opt = {
          url: "/api/games/channel_info/",
          type: "GET",
          data: {
            gid: gid
          }
        }
        const res = await getFetch(this, opt)
        if (res.code == 0) {
          this.game_channellist = []
          if (res.data.channel_address) {
            for (let i = 0; i < res.data.channel_address.length; i++) {
              var s = {value: res.data.channel_address[i], label: res.data.channel_address[i]}
              this.game_channellist.push(s)
            }
            this.channel_type = this.game_channellist[0].label
            this.getTargetSdk(this.channel_type)
          }

        }
      },
      //获取游戏对应的targetSDK版本
      async getTargetSdk(channel) {
        let opt = {
          url: "/api/games/target_version/",
          type: "GET",
          data: {
            gid: this.currentGameId,
            channel_name: channel,
          }
        }
        const res = await getFetch(this, opt)
        if (res.code == 0) {
          if (res.data.target_version) {
            for (let i = 0; i < res.data.target_version.length; i++) {
              var s = {value: res.data.target_version[i], label: res.data.target_version[i]}
              this.game_targetSDKlist.push(s)
            }
          }
        }
      },
      //请求平台获取投放形式数据
      async putinsData() {
        let key = this.$md5(window.Config.platform + new Date().getTime().toString().substring(0, 10) + window.Config.key)
        let opt = {

          url: "/api/putins",
          type: "GET",
          data: {
            sign: key,
            platform: window.Config.platform,
            timestamp: new Date().getTime().toString().substring(0, 10),
          }
        }
        const res = await getchanels93(this, opt);
        if (res.error_code === 0) {
          this.putInfolist = []
          for (var i = 0; i < res.data.length; i++) {
            var s = {value: res.data[i].id, label: res.data[i].name}
            this.putInfolist.push(s)
          }
          this.selectPtuType = this.putInfolist[0].label //设置默认选中第一个值
          this.currentPutStyleId = this.putInfolist[0].value;
          this.channelGroups();
        }
      },
      //请求平台获取渠道组列表数据
      async channelGroups() {
        let key = this.$md5(window.Config.platform + new Date().getTime().toString().substring(0, 10) + window.Config.key)
        let opt = {
          url: "/api/channel_groups",
          type: "GET",
          // data:window.Config.data
          data: {
            ad_putin: this.currentPutStyleId,
            sign: key,
            keyword: "",
            platform: window.Config.platform,
            timestamp: new Date().getTime().toString().substring(0, 10),
          }
        }
        const res = await getchanels93(this, opt);
        if (res.error_code === 0) {
          this.putGroup = [];
          for (var i = 0; i < res.data.length; i++) {
            var s = {value: res.data[i].id, label: res.data[i].name}
            this.putGroup.push(s)
          }
          this.selectGroup = this.putGroup[0].label //设置默认选中第一个值
          this.currentPutGroupId = this.putGroup[0].value
        }
      },
      //请求用户数据
      async userData() {
        let key = this.$md5(window.Config.platform + new Date().getTime().toString().substring(0, 10) + window.Config.key)
        let opt = {
          url: "/api/users",
          type: "GET",
          data: {
            game_id: "",//游戏ID
            ad_putin: "",//投放形式ID
            sign: key,//签名
            platform: window.Config.platform,//平台别名
            timestamp: new Date().getTime().toString().substring(0, 10),//请求时间戳
          }
        }
        const res = await getchanels93(this, opt);
        if (res.error_code === 0) {
          this.userList = []
          for (var i = 0; i < res.data.length; i++) {
            var s = {value: res.data[i].username, label: res.data[i].name}
            this.userList.push(s)
          }
          this.selectUser = this.userList[0].label //设置默认选中第一个值
          this.currentUserName = this.userList[0].label
        }
      },
      async channelsData() {
        let key = this.$md5(window.Config.platform + new Date().getTime().toString().substring(0, 10) + window.Config.key)
        let opt = {
          url: "/api/channels",
          type: "GET",
          data: {
            game_id: this.value4 ? '' : this.currentGameId,//游戏ID
            ad_putin: this.currentPutStyleId,//投放形式ID
            username: this.currentUserName,
            channel_group: this.currentPutGroupId,
            sign: key,//签名
            platform: window.Config.platform,//平台别名
            timestamp: new Date().getTime().toString().substring(0, 10),//请求时间戳
          }
        }
        const res = await getchanels93(this, opt);
        if (res.error_code === 0) {
          this.channellist = [];
          for (var i = 0; i < res.data.length; i++) {
            var s = {
              value: res.data[i].id,
              label: res.data[i].channel_name,
              ad_putin_name: res.data[i].ad_putin_name,
              short_name: res.data[i].short_name,
              check_url: res.data[i].click_url
            }
            this.channellist.push(s)
          }
        }
      },
      async getGameData(page, size) {
        let req_data = {}
        req_data['size'] = 50000
        req_data['page'] = 1
        let opt = {
          url: '/api/games/jsgen/',
          type: 'GET',
          data: req_data,
        }
        const res = await getFetch(this, opt);
        if (res.code === 0) {
          this.gamelist = []
          this.gamelist_all_data = res.data.games.results
          for (var i = 0; i < res.data.games.results.length; i++) {
            var s = {value: res.data.games.results[i].gid, label: res.data.games.results[i].name}
            this.gamelist.push(s)
          }
          if (this.gamelist.length !== 0) {
            this.selectGame = this.gamelist[0].label  //设置默认选中第一个值
            this.currentGameId = this.gamelist[0].value
          } else {
            this.selectGame = ''
            this.currentGameId = ''
          }
          // if (res.data.games.results.length !== 0) {
          //     this.channel_type = res.data.games.results[0].chennel_name
          // } else {
          //     this.channel_type = ''
          // }
          this.getChannel(this.currentGameId);
        }
      },
      //手游打包
      async buildAPI() {
        let opt = {
          url: "/api/apk/packing/",
          type: "post",
          data: {
            floor: this.floor,
            args: this.buildSendInfo,
          }
        }

        //console.log(this.buildSendInfo)
        const res = await getFetch(this, opt);
        if (res.code === 0) {
          alert("开始进行打包")
        }
      },


    },
    mounted() {
      this.getGameData();
      this.putinsData();
      this.channelGroups();
      this.userData();
      this.channelsData()
    },

  };
</script>
